import React from 'react';
import PageTitle from '../components/PageTitle.js';
import TabNav from "../components/TabNav.js";
import Footer from '../components/Footer';

export default function TabPage(props) {
    return (
        <div className="TabPage">
            <PageTitle>Athenos Adviesgroep - Bevoorschottings</PageTitle>
            <TabNav />
            <Footer />
        </div>
    );

}


